<template>
  <PopupBackground v-if="show">
    <div class="save-completed-popup smooth-shadow">
      <!-- Header -->
      <div class="header">
        <div class="title">
          <h3>Console Saved!</h3>
          <p>Your console has been saved successfully!</p>
        </div>
      </div>

      <!-- Contents -->
      <!-- <div class="contents">
        <label>Console Name</label>
        <input v-model="consoleName" type="text" placeholder="Enter your console name" />
        <label>Console Description</label>
        <input
          v-model="consoleDescription"
          type="text"
          placeholder="Enter the description of your console"
        />
      </div> -->

      <!-- Footer -->
      <div class="footer">
        <expand />
        <Button
          type="primary"
          icon="check"
          text="Done"
          @click="gotToConsoles"
        />
      </div>
    </div>
  </PopupBackground>
</template>

<script>
import PopupBackground from "@/components/modals/PopupBackground";
import Button from "@/components/global/views/Button";
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    show: Boolean,
    dashboard_id: Number,
  },
  components: {
    PopupBackground,
    Button,
  },
  computed: {},
  methods: {
    gotToConsoles() {
      this.$router.push("/dashboards");
    },
  },
};
</script>

<style lang="scss" scoped>
.save-completed-popup {
  display: flex;
  flex-direction: column;
  background: var(--color-secondary);
  border-radius: 5px;
  width: 80%;
  max-width: 450px;

  .header,
  .footer,
  .contents {
    padding: 10px;
  }

  .header {
    padding: 20px 15px 10px 15px;
    display: flex;
    align-items: center;

    .title {
      display: flex;
      flex-direction: column;

      h3 {
        font-weight: bold;
      }

      p {
        margin: 0;
        opacity: 0.5;
      }
    }
  }

  .contents {
    display: flex;
    flex-direction: column;
    padding: 15px;

    label {
      margin: 0 0 5px 0;
    }
    input {
      margin: 0 0 10px 0;
    }
  }

  .footer {
    background-color: var(--color-default-background);
    display: flex;
    align-items: center;
    border-radius: 0 0 5px 5px;
  }
}
</style>
